// @flow

/**
 * Axis Utilities for Chart Rendering
 * Groups yAxes by valueType and assigns left/right axis IDs
 */

type YAxisDef = {
  key: string,
  label: string,
  valueType: string,
};

type AxisGroup = {
  valueType: string,
  label: string,
  axes: YAxisDef[],
  yAxisId: 'left' | 'right',
  orientation: 'left' | 'right',
};

/**
 * Groups yAxes by valueType and assigns left/right axis IDs.
 * If all series share the same valueType, only a left axis is used.
 * If there are 2+ distinct valueTypes, the first group gets left, the second gets right.
 */
export function buildAxisAssignments(yAxes: YAxisDef[]): AxisGroup[] {
  const groups = [];
  const seen = new Map();

  for (const axis of yAxes) {
    const vt = axis.valueType;
    if (!seen.has(vt)) {
      seen.set(vt, groups.length);
      groups.push({ valueType: vt, label: axis.label, axes: [] });
    }
    groups[seen.get(vt)].axes.push(axis);
  }

  return groups.map((group, i) => ({
    ...group,
    yAxisId: i === 0 ? 'left' : 'right',
    orientation: i === 0 ? 'left' : 'right',
  }));
}
